module.exports = __webpack_public_path__ + "static/future-28d1e15588372e1f83aff6019d90f923.svg";